<template>
  <el-dialog
    :title="$t('editChainSupplier.editSupplier')"
    :visible.sync="dialogVisible"
    width="80%"
    @close="handleClose"
  >
    <el-form :model="editChainSupplierInfo" :rules="rules" ref="form" label-width="150px">
      <el-form-item :label="$t('editChainSupplier.supplierName')" prop="name">
        <el-input v-model="editChainSupplierInfo.name" :placeholder="$t('editChainSupplier.supplierNamePlaceholder')"></el-input>
      </el-form-item>
      
      <el-form-item :label="$t('editChainSupplier.appId')" prop="appId">
        <el-input v-model="editChainSupplierInfo.appId" :placeholder="$t('editChainSupplier.appIdPlaceholder')"></el-input>
      </el-form-item>
      
      <el-form-item :label="$t('editChainSupplier.appSecure')" prop="appSecure">
        <el-input v-model="editChainSupplierInfo.appSecure" :placeholder="$t('editChainSupplier.appSecurePlaceholder')"></el-input>
      </el-form-item>
      
      <el-form-item :label="$t('editChainSupplier.mchId')" prop="mchId">
        <el-input v-model="editChainSupplierInfo.mchId" :placeholder="$t('editChainSupplier.mchIdPlaceholder')"></el-input>
      </el-form-item>
      
      <el-form-item :label="$t('editChainSupplier.mchKey')" prop="mchKey">
        <el-input v-model="editChainSupplierInfo.mchKey" :placeholder="$t('editChainSupplier.mchKeyPlaceholder')"></el-input>
      </el-form-item>
      
      <el-form-item :label="$t('editChainSupplier.url')" prop="url">
        <el-input v-model="editChainSupplierInfo.url" :placeholder="$t('editChainSupplier.urlPlaceholder')"></el-input>
      </el-form-item>
      
      <el-form-item :label="$t('editChainSupplier.beanName')" prop="beanName">
        <el-input v-model="editChainSupplierInfo.beanName" :placeholder="$t('editChainSupplier.beanNamePlaceholder')"></el-input>
      </el-form-item>
      
      <el-form-item :label="$t('editChainSupplier.suType')" prop="suType">
        <el-select v-model="editChainSupplierInfo.suType" style="width:100%">
          <el-option :value="1" :label="$t('editChainSupplier.suType1')"></el-option>
          <el-option :value="2" :label="$t('editChainSupplier.suType2')"></el-option>
        </el-select>
      </el-form-item>
      
      <el-form-item :label="$t('editChainSupplier.remark')" prop="remark">
        <el-input 
          type="textarea"
          v-model="editChainSupplierInfo.remark"
          :placeholder="$t('editChainSupplier.remarkPlaceholder')"
        ></el-input>
      </el-form-item>
    </el-form>
    
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">{{$t('common.cancel')}}</el-button>
      <el-button type="primary" @click="editChainSupplier">{{$t('common.save')}}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { updateChainSupplier } from '@/api/admin/chainSupplier/chainSupplierApi'
import { getShopId } from '@/api/shop/shopApi'

export default {
  name: 'EditChainSupplier',
  data() {
    return {
      dialogVisible: false,
      editChainSupplierInfo: {
        csId: '',
        name: '',
        appId: '',
        appSecure: '',
        mchId: '',
        mchKey: '',
        url: '',
        remark: '',
        beanName: '',
        suType: 1,
        shopId: ''
      },
      rules: {
        name: [
          { required: true, message: this.$t('editChainSupplier.supplierNameRequired'), trigger: 'blur' },
          { max: 30, message: this.$t('editChainSupplier.supplierNameMaxLength'), trigger: 'blur' }
        ],
        appId: [
          { required: true, message: this.$t('editChainSupplier.appIdRequired'), trigger: 'blur' },
          { max: 500, message: this.$t('editChainSupplier.appIdMaxLength'), trigger: 'blur' }
        ],
        appSecure: [
          { required: true, message: this.$t('editChainSupplier.appSecureRequired'), trigger: 'blur' },
          { max: 500, message: this.$t('editChainSupplier.appSecureMaxLength'), trigger: 'blur' }
        ],
        mchId: [
          { required: true, message: this.$t('editChainSupplier.mchIdRequired'), trigger: 'blur' },
          { max: 32, message: this.$t('editChainSupplier.mchIdMaxLength'), trigger: 'blur' }
        ],
        mchKey: [
          { required: true, message: this.$t('editChainSupplier.mchKeyRequired'), trigger: 'blur' },
          { max: 128, message: this.$t('editChainSupplier.mchKeyMaxLength'), trigger: 'blur' }
        ],
        url: [
          { required: true, message: this.$t('editChainSupplier.urlRequired'), trigger: 'blur' },
          { max: 128, message: this.$t('editChainSupplier.urlMaxLength'), trigger: 'blur' }
        ],
        beanName: [
          { required: true, message: this.$t('editChainSupplier.beanNameRequired'), trigger: 'blur' },
          { max: 50, message: this.$t('editChainSupplier.beanNameMaxLength'), trigger: 'blur' }
        ],
        csId: [
          { required: true, message: this.$t('editChainSupplier.supplierIdRequired'), trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    open(chainSupplier) {
      this.dialogVisible = true
      this.editChainSupplierInfo = {
        ...chainSupplier,
        shopId: getShopId()
      }
    },
    async editChainSupplier() {
      this.$refs.form.validate(async (valid) => {
        if (!valid) return
        
        const {code, msg} = await updateChainSupplier(this.editChainSupplierInfo)
        if (code == 0) {
          this.$message.success(this.$t('common.saveSuccess'))
          this.dialogVisible = false
          this.$emit('success')
        } else {
          this.$message.error(msg)
        }
      })
    },
    handleClose() {
      this.$refs.form.resetFields()
    }
  }
}
</script>

<style scoped>
.el-input, .el-textarea {
  width: 100%;
}
</style>